import styled from 'styled-components';
import { useTranslation } from "react-i18next";
import {useEffect} from "react";
import {setGlobalShowFeedBack} from "../../utils/tipsService";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  /* 根据 isFullPage 来决定渲染尺寸 */
  ${({ isFullPage }) => isFullPage
    ? `
      width: 100vw;
      height: 100vh;
    `
    : `
      width: 100%;
      height: 100%;
    `
}

  background: #121317;
  color: white;
  font-size: 20px;
`;

const ErrorHeader = styled.header`
  font-size: 1.5em; 
  margin-bottom: 2rem;
`;

const ErrorMessage = styled.main`
  font-size: 0.7em;
  margin-bottom: 1rem;
  text-align: center; 
  max-width: 80%; 
`;

const Button = styled.button`
  font-size: 0.7em; 
  padding: 0.5em 1em;
  color: black; 
  background-color: white; 
  border: none;
  border-radius: 0.3em;
  cursor: pointer;
  margin: 1rem 0rem 0rem 0rem; 

  &:hover {
    background-color: #e0e0e0; 
  }
`;

const TextButton = styled.button`
  background: none;
  border: none;
  color: white;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.6em;
  margin-top: 0.8rem;
  
  &:hover {
    text-decoration: none;
    color: #e0e0e0;
  }
`;

function ErrorPage({ errorCode, errorMessage, isFullPage = false, resetError = false }) {
    const { t } = useTranslation();

    if (errorCode === 404) {
        errorMessage = t('ERROR_CODE_MESS_1');
    } else if (!errorMessage) {
        errorMessage = t('ERROR_CODE_MESS_2');
    } else {
        errorMessage = `We're sorry, an error has occurred: ${errorMessage}. Please contact us for more information.`;
    }

    const handleClick = () => {
        window.location.href = '/';
    };

    const handleClearCache = () => {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/';
    };

    useEffect(() => {
        setGlobalShowFeedBack(true);
    }, []);

    return (
        <Page isFullPage={isFullPage}>
            <ErrorHeader>Oops!</ErrorHeader>
            <ErrorMessage>{errorMessage}</ErrorMessage>
            <ErrorMessage>{t('ERROR_PAGE_INFO')}</ErrorMessage>
            {resetError ? (
                <Button onClick={resetError}>
                    {'Reset'}
                </Button>
            ) : (
                <Button onClick={handleClick}>
                    {'Back to Hyper3D'}
                </Button>
            )}
            <TextButton onClick={handleClearCache}>
                {'Still have issue? Try Clear Cache'}
            </TextButton>
        </Page>
    );
}

export { ErrorPage };
